import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Accueil from './screens/Accueil';
import Etatcivil from './screens/Etatcivil';
import Etude from './screens/Etude';
import Resume from './screens/Resume';
import Experience from './screens/Experience';
import Competence from './screens/Competence';
import Fichier from './screens/Fichier';
import Finaly from './screens/Finaly';
import DomaineCompetence from './screens/DomaineComptence';
import HistoriqueDeDemande from './screens/HistoriqueDeDemande';
import PretentionEtChoixLocalisation from './screens/PretentionEtChoixLocalisation';
import Admin from './screens/Admin';
import ListCandidat from './screens/ListCandidat';
import Disponibilite from './screens/Disponibilite';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/etatcivil" element={<Etatcivil />} />
        <Route path="/etude" element={<Etude />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/competence" element={<DomaineCompetence />} />
        <Route path="/autrecompetence" element={<Competence />} />
        <Route path="/disponibilite" element={<Disponibilite />} />
        <Route path="/pretention_location" element={<PretentionEtChoixLocalisation />} />
        <Route path="/fichier" element={<Fichier />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/finaly" element={<Finaly />} />
        <Route path="/historique" element={<HistoriqueDeDemande />} />
        <Route path="/administrations" element={<Admin />} />
        <Route path="/administrations/liste_candidat_externe" element={<ListCandidat />} />
      </Routes>
    </div>
  );
}

export default App;
